<!-- eslint-disable max-len -->
<template>
  <v-main>
    <UseIdle
      v-slot="{ idle }"
      :timeout="30 * 1000"
    >
      {{ idle ? saveData() : '' }}
    </UseIdle>
    <v-dialog
      v-model="isImpersonated"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title>Account Locked</v-card-title>
        <v-card-text>You're account is locked while an admin is logged in. Please try again later by pressing the button below</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="checkAgain"
          >
            Check Again
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-stepper
        flat
        style="background-color: transparent;"
        alt-labels
        v-model="currentStep"
      >
        <StepHeader/>
        <v-row>
          <v-col cols="12">
            <v-stepper-items class="mt-12">
              <BStep1 />
              <BStep2 />
              <BStep3 />
              <BStep4 />
              <BStep5 />
              <BStep6 />
            </v-stepper-items>
          </v-col>
        </v-row>
      </v-stepper>
      <v-snackbar
        v-model="ShowSnackBar"
        :timeout="2000"
        top
        :dark="!$vuetify.theme.dark"
        :light="$vuetify.theme.dark"
      >
        {{ SnackBarMsg }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { UseIdle } from '@vueuse/components';
import StepHeader from './StepHeader.vue';
import BStep1 from './Steps/b1Step.vue';
import BStep2 from './Steps/b2Step.vue';
import BStep3 from './Steps/b3Step.vue';
import BStep4 from './Steps/b4Step.vue';
import BStep5 from './Steps/b5Step.vue';
import BStep6 from './Steps/b6Step.vue';

export default {
  name: 'FormsBase',
  components: {
    StepHeader,
    BStep1,
    BStep2,
    BStep3,
    BStep4,
    BStep5,
    BStep6,
    UseIdle,
  },
  data: () => ({
    temp: null,
  }),
  created() {
    const token = localStorage.getItem('token');
    if (token) {
      this.$store.dispatch('validateToken');
    }
  },
  watch: {
    currentStep(newValue, oldValue) {
      if (oldValue !== 'B1') {
        if (this.currentStatus !== 'Signed') {
          this.currentStatus = 'In Progress';
        }
        this.$store.commit('updateBenefitsStateStep', newValue);
        this.$store.dispatch('updatePacketInfo');
      }
    },
  },
  computed: {
    currentStep: {
      get() {
        return this.$store.state.benefitsPacket.state.step;
      },
      set(value) {
        this.$store.commit('updateBenefitsStateStep', value);
      },
    },
    currentStatus: {
      get() {
        return this.$store.state.benefitsPacket.state.status;
      },
      set(value) {
        this.$store.commit('updateBenefitsStateStatus', value);
      },
    },
    SnackBarMsg() {
      return this.$store.state.snackbar.message;
    },
    ShowSnackBar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit('updateSnackbarShow', value);
      },
    },
    isImpersonated() {
      if (this.$store.state.userInfo.impersonated) {
        return false;
      }

      if (this.$store.state.prospectPacket === null) {
        return false;
      }
      return this.$store.state.prospectPacket.loggedInUser.impersonated;
    },
  },
  methods: {
    checkAgain() {
      this.$store.dispatch('GetProspectPacket');
    },
    saveData() {
      this.$store.dispatch('updatePacketInfo');
    },
  },
};
</script>

<style lang="scss">
#intro.v-list.v-sheet.theme--dark {
  background-color: transparent !important;
}
#comboTheme.theme--dark.v-list {
  background: unset !important;
  color: #FFFFFF;
}
div.theme--dark .v-picker__actions.v-card__actions {
  background: #424242;
}
div.theme--dark div.v-picker__title {
  background: gray;
}
</style>
